import Target_0 from './src/Checkout.jsx';shopify.extend('purchase.checkout.block.render', (...args) => Target_0(...args));